import React, {useEffect, useState} from 'react';
import axios from '../Common/axios';
import { useParams } from 'react-router-dom';
import {Tabs, Button, Layout, Modal} from "antd";
import {  ExclamationCircleFilled  } from '@ant-design/icons';
import Measure from './InfoMeasure';
import Suggest from './InfoSuggest';
import Threat from './InfoThreat';
import Risk from './InfoRisk';
import Corrective from './InfoCorrective';
import Cookies from 'js-cookie';
import {getFindReportIdInfo, postDeleteVaReportData} from '../Common/api';
// import Cookies from 'js-cookie';

const {Content } = Layout;
const {TabPane} = Tabs;


function TemplateInfo({ p_reportId, onClose }) {
    const params = useParams();
    //console.log(params.reportId);

    // 변수 선언
    const [companyCode, setCompanyCode] = useState('');
    const [assetType, setAssetType] = useState('');
    const [reportName, setReportName] = useState('');
    const [reportId, setReportId] = useState(p_reportId || params.reportId);
    const [isLoading, setIsLoading] = useState(false);
    const [isRegAuth, setIsRegAuth] = useState(false);
    const titleName="템플릿 삭제";

    // if(Cookies.get("auth_superuser") === 'true'){
    //     setIsRegAuth(true);
    // }else{        
    //     setIsRegAuth(false);
    // }
    const increment = () => setIsRegAuth(true);
    
    useEffect(() => {
        //자동조회
        if(reportId) {
            axios.get(getFindReportIdInfo(reportId))
                .then((response) => {
                    //console.log(response);
                    if(response.data && response.data.length > 0) {
                        setCompanyCode(response.data[0].com_cd);
                        setAssetType(response.data[0].asset_type);
                        setReportName(response.data[0].report_nm);
                        setReportId(response.data[0].report_id);
                    }
                })
                .catch((error) => {
                    console.log("TemplateInfo.js ------- 28 에러");
                    console.dir(error);
                });
        }
    }, [reportId]);

    // 닫기
    const onClickCloseHandler = () => {
        if (onClose) {
            onClose(true);
        } else {
            window.close();
        }
    }

    // 삭제 전 확인
    const onClickDeleteHandler = () => {

        Modal.confirm({
            title: '정말로 삭제하시겠습니까?',
            content: '템플릿을 삭제하면 아래 기준과 결과 레포트가 모두 삭제됩니다.',
            icon: <ExclamationCircleFilled />,
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                fnDeleteVaReportData();
            },
        });
    }

    // 삭제
    const fnDeleteVaReportData = () => {

        setIsLoading(true);
        axios.post(postDeleteVaReportData(), {
            reportId : reportId,
          }, {logParam : reportId})
          .then((response) => {
            //console.log(response);
            setIsLoading(false);
            //Modal.info({title: "OK.", okText:"Close"});
            if(response.data == '보고서 삭제가 완료되었습니다.') {
                Modal.info({title:titleName, content:"템플릿 삭제가 완료되었습니다.", okText:"Close", onOk() {
                    //정상적으로 삭제된 경우, 부모창을 재조회하고 팝업창을 닫는다.
                    onClose?.(true);
                    //window.close();
                }});
            } else {
                Modal.info({title:titleName, content:response.data, okText:"Close"});  
            }
        })
        .catch((error) => {
            setIsLoading(false);
            Modal.error({title:titleName, content:error.message, okText:"Close"});
        });

    }

    // reportInfo 객체 생성
    const reportInfo = {
        com_cd: companyCode,
        asset_type: assetType,
        report_nm: reportName,
        report_id: reportId
    };

    const tabItems = [
        {
            label: '진단항목',
            key: '1',
            children: <Measure reportId={reportId} />,
        },
        {
            label: '권고사항',
            key: '2',
            children: <Suggest reportId={reportId} />,
        },
        {
            label: '위협(Threat)',
            key: '3',
            children: <Threat reportId={reportId} />,
        },
        // {
        //     label: '예외사항',
        //     key: '5',
        //     children: <Corrective reportId={reportId} />,
        // }
    ];

    if(true){
        tabItems.splice(3,0,
            {
                label: '위험(Risk)',
                key: '4',
                children: <Risk reportId={reportId} reportInfo={reportInfo} />,
            }
        );
    }

    // 새 창으로 열렸는지 확인 (onClose prop이 없으면 새 창)
    const isNewWindow = !onClose;
    
    const contentStyle = isNewWindow ? {
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
    } : {};
    
    const sectionStyle = isNewWindow ? {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
    } : {};
    
    const content = (
        <>
            <div className='popup_header'>
                <div className='popup_title'>
                    템플릿 관리
                </div>
            </div>
            <div className="popup_button" style={{top:'10px'}}>
                {isRegAuth ? (
                    <Button
                        type="default"
                        onClick={onClickDeleteHandler}
                        style={{marginLeft: '10px'}}
                        loading={isLoading}
                    >
                        {'템플릿 삭제'}
                    </Button>
                ):(<></>)}
                    <Button
                        type="default"
                        onClick={onClickCloseHandler}
                        style={{marginLeft: '10px', marginTop: isNewWindow ? '8px' : '0'}}
                    >
                        {'닫기'}
                    </Button>
                </div>
                <div className="section">
                    <table className='search'>
                        <colgroup>
                            <col style={{width:'10%'}} />
                            <col style={{width:'20%'}} />
                            <col style={{width:'10%'}} />
                            <col style={{width:'30%'}} />
                            <col style={{width:'10%'}} />
                            <col style={{width:'20%'}} />
                        </colgroup>
                        <tbody>
                        <tr>
                            <th>자산구분</th>
                            <td>{assetType}</td>
                            <th>템플릿명</th>
                            <td>{reportName}</td>
                            <th>템플릿ID</th>
                            <td>{reportId}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="section" style={{borderTop: '0', ...sectionStyle}}>
                    <Content style={{ 
                        backgroundColor: '#f5f5f5', 
                        flex: isNewWindow ? 1 : 'auto', 
                        height: isNewWindow ? '100%' : 'auto',
                        display: isNewWindow ? 'flex' : 'block',
                        flexDirection: 'column',
                        overflow: 'hidden'
                    }}>
                        <Tabs 
                            defaultActiveKey="1" 
                            type={'card'} 
                            items={tabItems} 
                            style={{
                                height: isNewWindow ? '100%' : 'auto',
                                display: isNewWindow ? 'flex' : 'block',
                                flexDirection: 'column'
                            }}
                            className={isNewWindow ? "full-height-tabs" : ""}
                        />
                    </Content>
                </div>
        </>
    );
    
    return isNewWindow ? (
        <div style={contentStyle}>
            {content}
        </div>
    ) : (
        <div className='layer_overlay'>
            <div className='layer_wrap' style={{width:Math.ceil( window.innerWidth - 100 ), height:Math.ceil( window.innerHeight - 200 )}}>
                {content}
            </div>
        </div>
    );
}

export default TemplateInfo;